import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import Download from "../pages/download/page";
import Features from "../pages/features/page";
import HotComics from "../pages/hot-comics/page";
import Reviews from "../pages/reviews/page";
import About from "../pages/about/page";
import Help from "../pages/help/page";
import Categories from "../pages/categories/page";
import Schedule from "../pages/schedule/page";
import Creator from "../pages/creator/page";
import Careers from "../pages/careers/page";
import Privacy from "../pages/privacy/page";
import Terms from "../pages/terms/page";
import Report from "../pages/report/page";

const routes: RouteObject[] = [
  {
    path: "/report",
    element: <Report />,
  },
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "download", element: <Download /> },
      { path: "features", element: <Features /> },
      { path: "hot-comics", element: <HotComics /> },
      { path: "reviews", element: <Reviews /> },
      { path: "about", element: <About /> },
      { path: "help", element: <Help /> },
      { path: "categories", element: <Categories /> },
      { path: "schedule", element: <Schedule /> },
      { path: "creator", element: <Creator /> },
      { path: "careers", element: <Careers /> },
      { path: "privacy", element: <Privacy /> },
      { path: "terms", element: <Terms /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;